import { coverageColor } from '@mollusk/shared';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const STOPS: Array<{ label: string; at: number }> = [
  { label: 'None', at: 0 },
  { label: '<25%', at: 0.1 },
  { label: '25–60%', at: 0.4 },
  { label: '60–99%', at: 0.8 },
  { label: 'Full', at: 1 },
];

// Jurisdiction-polygon key for the target (key-target / five-year) views.
const MEMBERSHIP: Array<{ label: string; color: string }> = [
  { label: 'Covered', color: '#f59e0b' },
  { label: 'Thin / partial data', color: '#94a3b8' },
];

const SWATCH = {
  width: 14,
  height: 14,
  borderRadius: 0.5,
  border: '1px solid rgba(0,0,0,0.2)',
} as const;

const PAPER_SX = {
  position: 'absolute',
  bottom: 12,
  left: 12,
  p: 1,
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  flexWrap: 'wrap',
} as const;

function Swatch({ color, label }: { color: string; label: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Box sx={{ ...SWATCH, bgcolor: color }} />
      <Typography variant="caption">{label}</Typography>
    </Box>
  );
}

/**
 * Map legend. Always shows the choropleth coverage ramp; when `showMembership`
 * is set (maps that draw jurisdiction polygons) it appends the covered vs.
 * thin/partial polygon key.
 */
export function CoverageLegend({
  unit,
  showMembership = false,
}: {
  unit: string;
  showMembership?: boolean;
}) {
  return (
    <Paper elevation={3} sx={PAPER_SX}>
      <Typography variant="caption" sx={{ mr: 0.5 }}>
        Coverage ({unit})
      </Typography>
      {STOPS.map((s) => (
        <Swatch key={s.label} color={coverageColor(s.at)} label={s.label} />
      ))}
      {showMembership ? (
        <>
          <Divider orientation="vertical" flexItem />
          <Typography variant="caption" sx={{ mr: 0.5 }}>
            Polygons
          </Typography>
          {MEMBERSHIP.map((m) => (
            <Swatch key={m.label} color={m.color} label={m.label} />
          ))}
        </>
      ) : null}
    </Paper>
  );
}
